export default __webpack_public_path__ + "static/media/hostaway_step10.9b269b46.jpg";